import React from 'react';
import ReactDOM from 'react-dom';

// RootPortal allows React to inject elements into <div id="root />
class RootPortal extends React.Component {
  constructor(props) {
    super(props);

    // We can even customize the style via the props.
    const { style } = this.props;

    this.el = document.createElement('div');
    if (style) {
      Object.keys(style).forEach(key => {
        this.el.style[key] = style[key];
      });
    }
  }

  componentDidMount() {
    const HeaderPortalRoot = document.getElementById('root');
    if (HeaderPortalRoot) {
      HeaderPortalRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    const HeaderPortalRoot = document.getElementById('root');
    if (HeaderPortalRoot) {
      try {
        HeaderPortalRoot.removeChild(this.el);
      } catch {
        // The children might already be removed due to a React state change
        // that is out of our control thus we will do nothing here as React
        // will complain this.el not longer is a child of HeaderPortalRoot
      }
    }
  }

  render() {
    const {
      props: { children },
      el,
    } = this;

    return ReactDOM.createPortal(children, el);
  }
}

export default RootPortal;
